// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
// getModulesInfotools, getModuleInfotools
import {
    getModulesInfotools as listModulesInfotoolsAPI,
    getModuleInfotools as getModuleInfotoolsAPI,
    // addModuleInfotools as addModuleInfotoolsAPI,
    // updateModuleInfotools as updateModuleInfotoolsAPI,
    // deleteModuleInfotools as deleteModuleInfotoolsAPI,
} from '../../helpers/';

import { moduleInfotoolsApiResponseError, moduleInfotoolsApiResponseSuccess } from './actions';
import { ModuleInfotoolsActionTypes } from './constants';

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getModuleInfotools({ payload: { key } }) {
    try {
        const response = yield call(getModuleInfotoolsAPI, key);
        const moduleInfotoolsItem = response.data.data;
        yield put(moduleInfotoolsApiResponseSuccess(ModuleInfotoolsActionTypes.GET_MODULE_INFOTOOLS, moduleInfotoolsItem));
    } catch (error) {
        yield put(moduleInfotoolsApiResponseError(ModuleInfotoolsActionTypes.GET_MODULE_INFOTOOLS, error));
    }
}

// function* addModuleInfotools({payload:moduleInfotools}){
//     try{
//         const response = yield call(addModuleInfotoolsAPI,{...moduleInfotools})
//         const moduleInfotoolsItem = response.data
//         yield put(moduleInfotoolsApiResponseSuccess(ModuleInfotoolsActionTypes.ADD_MODULE_INFOTOOLS,moduleInfotoolsItem))
//     } catch(error){
//         yield put(moduleInfotoolsApiResponseError(ModuleInfotoolsActionTypes.ADD_MODULE_INFOTOOLS,error))
//     }
// }

// function* updateModuleInfotools({payload:moduleInfotools}){
//     try{
//         const response = yield call(updateModuleInfotoolsAPI,{...moduleInfotools})
//         const moduleInfotoolsItem = response.data.data
//         yield put(moduleInfotoolsApiResponseSuccess(ModuleInfotoolsActionTypes.UPDATE_MODULE_INFOTOOLS,moduleInfotoolsItem))
//     }catch(error){
//         yield put(moduleInfotoolsApiResponseError(ModuleInfotoolsActionTypes.UPDATE_MODULE_INFOTOOLS,error))
//     }
// }
// function* deleteModuleInfotools({payload:{id}}){
//     try{
//         const response = yield call(deleteModuleInfotoolsAPI,id)
//         const moduleInfotoolsItem = response.data.id
//         yield put(moduleInfotoolsApiResponseSuccess(ModuleInfotoolsActionTypes.DELETE_MODULE_INFOTOOLS,moduleInfotoolsItem))
//     }catch(error){
//         yield put(moduleInfotoolsApiResponseError(ModuleInfotoolsActionTypes.DELETE_MODULE_INFOTOOLS,error))
//     }
// }

/**
 * List contactos
 */
function* listModulesInfotools({ payload: params }) {
    try {
        const response = yield call(listModulesInfotoolsAPI, { ...params });
        const listaModulesInfotools = response.data.data;
        yield put(moduleInfotoolsApiResponseSuccess(ModuleInfotoolsActionTypes.LIST_MODULES_INFOTOOLS, listaModulesInfotools));
    } catch (error) {
        yield put(moduleInfotoolsApiResponseError(ModuleInfotoolsActionTypes.LIST_MODULES_INFOTOOLS, error));
    }
}


export function* watchGetModuleInfotools(): any {
    yield takeEvery(ModuleInfotoolsActionTypes.GET_MODULE_INFOTOOLS, getModuleInfotools);
}

export function* watchListModulesInfotools(): any {
    yield takeEvery(ModuleInfotoolsActionTypes.LIST_MODULES_INFOTOOLS, listModulesInfotools);
}

// export function* watchAddModuleInfotools(): any {
//     yield takeEvery(ModuleInfotoolsActionTypes.ADD_MODULE_INFOTOOLS, addModuleInfotools)
// }
// export function* watchUpdateModuleInfotools(): any {
//     yield takeEvery(ModuleInfotoolsActionTypes.UPDATE_MODULE_INFOTOOLS, updateModuleInfotools)
// }
// export function* watchDeleteModuleInfotools(): any {
//     yield takeEvery(ModuleInfotoolsActionTypes.DELETE_MODULE_INFOTOOLS, deleteModuleInfotools)
// }


function* moduleInfotoolsSaga(): any {
    yield all([
        fork(watchGetModuleInfotools),
        fork(watchListModulesInfotools),
        // fork(watchAddModuleInfotools),
        // fork(watchUpdateModuleInfotools),
        // fork(watchDeleteModuleInfotools),
    ]);
}

export default moduleInfotoolsSaga;
